import { useState } from 'react';

interface HeaderProps {
    onMenuToggle: () => void;
    isSidebarOpen: boolean;
}

const Header = ({ onMenuToggle }: HeaderProps) => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);

    const toggleProfile = () => setIsProfileOpen(!isProfileOpen);
    const toggleNotification = () => setIsNotificationOpen(!isNotificationOpen);

    return (
        <header className="app-header">
            <div className="main-header-container container-fluid">
                <div className="header-content-left">
                    <div className="header-element">
                        <div className="horizontal-logo">
                            <a href="/" className="header-logo">
                                <img
                                    src="/images/common/logo/logo_dark.png"
                                    alt="logo"
                                    className="desktop-logo"
                                />
                                <img
                                    src="/images/common/logo/logo_short_dark.png"
                                    alt="logo"
                                    className="toggle-logo"
                                />
                                <img
                                    src="/images/common/logo/logo_lite.png"
                                    alt="logo"
                                    className="desktop-white"
                                />
                                <img
                                    src="/images/common/logo/logo_short_lite.png"
                                    alt="logo"
                                    className="toggle-white"
                                />
                            </a>
                        </div>
                    </div>

                    <div className="header-element">
                        <a
                            aria-label="Hide Sidebar"
                            className="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle"
                            onClick={onMenuToggle}
                            href="#"
                        >
                            <span></span>
                        </a>
                    </div>
                </div>

                <div className="header-content-right">
                    {/* 검색 */}
                    <div className="header-element header-search">
                        <a
                            href="#"
                            className="header-link"
                            data-bs-toggle="modal"
                            data-bs-target="#searchModal"
                        >
                            <i className="bx bx-search-alt-2 header-link-icon"></i>
                        </a>
                    </div>

                    {/* 국가 선택 */}
                    {/*<div className="header-element country-selector">
                        <a
                            href="#"
                            className="header-link dropdown-toggle"
                            data-bs-toggle="dropdown"
                        >
                            <img
                                src="/images/flags/us_flag.jpg"
                                alt="img"
                                className="rounded-1"
                            />
                        </a>
                        <ul className="main-header-dropdown dropdown-menu dropdown-menu-end">
                            <li>
                                <a
                                    className="dropdown-item d-flex align-items-center"
                                    href="#"
                                >
                                    <span className="avatar avatar-xs lh-1 me-2">
                                        <img
                                            src="/images/flags/us_flag.jpg"
                                            alt="img"
                                        />
                                    </span>
                                    English
                                </a>
                            </li>
                            <li>
                                <a
                                    className="dropdown-item d-flex align-items-center"
                                    href="#"
                                >
                                    <span className="avatar avatar-xs lh-1 me-2">
                                        <img
                                            src="/images/flags/spain_flag.jpg"
                                            alt="img"
                                        />
                                    </span>
                                    Spanish
                                </a>
                            </li>
                            <li>
                                <a
                                    className="dropdown-item d-flex align-items-center"
                                    href="#"
                                >
                                    <span className="avatar avatar-xs lh-1 me-2">
                                        <img
                                            src="/images/flags/french_flag.jpg"
                                            alt="img"
                                        />
                                    </span>
                                    French
                                </a>
                            </li>
                        </ul>
                    </div>*/}

                    {/* 테마 토글 */}
                    <div className="header-element header-theme-mode">
                        <a href="#" className="header-link layout-setting">
                            <span className="light-layout">
                                <i className="bx bx-moon header-link-icon"></i>
                            </span>
                            <span className="dark-layout">
                                <i className="bx bx-sun header-link-icon"></i>
                            </span>
                        </a>
                    </div>

                    {/* 장바구니 */}
                    <div className="header-element cart-dropdown">
                        <a
                            href="#"
                            className="header-link dropdown-toggle"
                            data-bs-toggle="dropdown"
                        >
                            <i className="bx bx-cart header-link-icon"></i>
                            <span
                                className="badge bg-primary rounded-pill header-icon-badge"
                                id="cart-icon-badge"
                            >
                                5
                            </span>
                        </a>
                        <div className="main-header-dropdown dropdown-menu dropdown-menu-end">
                            <div className="p-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="mb-0 fs-17 fw-semibold">
                                        Cart Items
                                    </p>
                                    <span
                                        className="badge bg-success-transparent"
                                        id="cart-data"
                                    >
                                        5 Items
                                    </span>
                                </div>
                            </div>
                            <div className="dropdown-divider"></div>
                            <ul
                                className="list-unstyled mb-0"
                                id="header-cart-items-scroll"
                            >
                                <li className="dropdown-item">
                                    <div className="d-flex align-items-start cart-dropdown-item">
                                        <img
                                            src="/images/ecommerce/jpg/1.jpg"
                                            alt="img"
                                            className="avatar avatar-sm avatar-rounded br-5 me-3"
                                        />
                                        <div className="flex-grow-1">
                                            <div className="d-flex align-items-start justify-content-between mb-0">
                                                <div className="mb-0 fs-13 text-dark fw-semibold">
                                                    <a href="cart.html">
                                                        SomeThing Phone
                                                    </a>
                                                </div>
                                                <div>
                                                    <span className="text-black mb-1">
                                                        $1,299.00
                                                    </span>
                                                    <a
                                                        href="#"
                                                        className="header-cart-remove float-end dropdown-item-close"
                                                    >
                                                        <i className="ti ti-trash"></i>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="min-w-fit-content d-flex align-items-start justify-content-between">
                                                <ul className="header-product-item d-flex">
                                                    <li>Color: Red</li>
                                                    <li>
                                                        Size:{' '}
                                                        <span className="fw-semibold">
                                                            Large
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div className="p-3 empty-header-item border-top">
                                <div className="d-grid">
                                    <a
                                        href="checkout.html"
                                        className="btn btn-primary"
                                    >
                                        Proceed to checkout
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 알림 */}
                    <div className="header-element notifications-dropdown">
                        <a
                            href="#"
                            className="header-link dropdown-toggle"
                            onClick={toggleNotification}
                        >
                            <i className="bx bx-bell header-link-icon"></i>
                            <span
                                className="badge bg-secondary rounded-pill header-icon-badge pulse pulse-secondary"
                                id="notification-icon-badge"
                            >
                                5
                            </span>
                        </a>
                        {isNotificationOpen && (
                            <div className="main-header-dropdown dropdown-menu dropdown-menu-end show">
                                <div className="p-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 fs-17 fw-semibold">
                                            Notifications
                                        </p>
                                        <span
                                            className="badge bg-secondary-transparent"
                                            id="notifiation-data"
                                        >
                                            5 Unread
                                        </span>
                                    </div>
                                </div>
                                <div className="dropdown-divider"></div>
                                <ul
                                    className="list-unstyled mb-0"
                                    id="header-notification-scroll"
                                >
                                    <li className="dropdown-item">
                                        <div className="d-flex align-items-start">
                                            <div className="pe-2">
                                                <span className="avatar avatar-md bg-primary-transparent avatar-rounded">
                                                    <i className="ti ti-gift fs-18"></i>
                                                </span>
                                            </div>
                                            <div className="flex-grow-1 d-flex align-items-center justify-content-between">
                                                <div>
                                                    <p className="mb-0 fw-semibold">
                                                        <a href="notifications.html">
                                                            Your Order Has Been
                                                            Shipped
                                                        </a>
                                                    </p>
                                                    <span className="text-muted fw-normal fs-12 header-notification-text">
                                                        Order No: 123456 Has
                                                        Shipped To Your Delivery
                                                        Address
                                                    </span>
                                                </div>
                                                <div>
                                                    <a
                                                        href="#"
                                                        className="min-w-fit-content text-muted me-1 dropdown-item-close1"
                                                    >
                                                        <i className="ti ti-x fs-16"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div className="p-3 empty-header-item1 border-top">
                                    <div className="d-grid">
                                        <a
                                            href="notifications.html"
                                            className="btn btn-primary"
                                        >
                                            View All
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* 풀스크린 */}
                    <div className="header-element">
                        <a
                            href="#"
                            className="header-link"
                            id="switcher-fullscreen"
                        >
                            <i className="bx bx-fullscreen full-screen-open header-link-icon"></i>
                            <i className="bx bx-exit-fullscreen full-screen-close header-link-icon d-none"></i>
                        </a>
                    </div>

                    {/* 프로필 드롭다운 */}
                    <div className="header-element">
                        <a
                            href="#"
                            className="header-link dropdown-toggle"
                            onClick={toggleProfile}
                        >
                            <img
                                src="/images/common/df_logo.png"
                                alt="img"
                                className="avatar avatar-sm avatar-rounded"
                            />
                        </a>
                        {isProfileOpen && (
                            <div className="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end show">
                                <div className="header-profile-header">
                                    <div className="header-profile-info">
                                        <div className="header-profile-name">
                                            <p className="mb-0 text-white">
                                                Json Taylor
                                            </p>
                                        </div>
                                        <div className="header-profile-role">
                                            <p className="mb-0 text-white-50">
                                                Web Designer
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="header-profile-body">
                                    <a
                                        href="profile.html"
                                        className="dropdown-item"
                                    >
                                        <i className="ti ti-user-circle fs-18 me-2 op-7"></i>
                                        Profile
                                    </a>
                                    <a
                                        href="mail.html"
                                        className="dropdown-item"
                                    >
                                        <i className="ti ti-inbox fs-18 me-2 op-7"></i>
                                        Inbox{' '}
                                        <span className="badge bg-success-transparent ms-auto">
                                            25
                                        </span>
                                    </a>
                                    <a
                                        href="todolist.html"
                                        className="dropdown-item"
                                    >
                                        <i className="ti ti-clipboard-check fs-18 me-2 op-7"></i>
                                        Task Manager
                                    </a>
                                    <a
                                        href="settings.html"
                                        className="dropdown-item"
                                    >
                                        <i className="ti ti-settings fs-18 me-2 op-7"></i>
                                        Settings
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        className="dropdown-item"
                                    >
                                        <i className="ti ti-currency-dollar fs-18 me-2 op-7"></i>
                                        Bal: $7,12,950
                                    </a>
                                    <a
                                        href="signin.html"
                                        className="dropdown-item"
                                    >
                                        <i className="ti ti-logout fs-18 me-2 op-7"></i>
                                        Log Out
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* 사이드바 토글 */}
                    <div className="header-element">
                        <a
                            href="#"
                            className="header-link switcher-icon"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#switcher-canvas"
                        >
                            <i className="bx bx-cog header-link-icon"></i>
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
